import React, { useState, useEffect } from 'react';
import {
    ChatBtn,
} from "../../CommonPages/ClaimRaise/OrderTabs/trackDetailTypeOneStyled";
import { useHistory } from 'react-router-dom';
import { Container } from "web/components/ChatBox/ChatBoxStyled";
import AdminMessageCount from "./AdminMessageCount"
import { updateReceivedClaimMessageForAdmin } from 'redux/actions/myClaims';
import { useDispatch, useSelector } from 'react-redux';
import { BiChat } from "react-icons/bi";
// import AdminChatBox from "./adminchatboxComponent"
import AdminBuyerChatBox from "./adminbuyerchatboxComponent"
import AdminSellerChatBox from "./adminsellerchatboxComponent"
import * as moment from 'moment';
import Pagination from '@material-ui/lab/Pagination';
import { InnerBoxes } from './ClaimStyled'
import { downloadFile } from 'redux/actions/helper/downloadFile';
function ClaimDetails(props) {
    const dispatch = useDispatch();
    let history = useHistory()
    let claimsDataList = props.claimsDataList
    let tabType = props.tabType
    let pageNumber = props.pageNumber
    let totalPagesCount = props.totalPagesCount
    const [userTypeforApi, setuserTypeforApi] = useState("")
    // const [claimRaisedToggleForBuyer,setclaimRaisedToggleForBuyer]  = useState(false) 
    // const [claimRaisedToggleForSeller,setclaimRaisedToggleForSeller] = useState(false)
    const [selectOrderId, setselectOrderId] = useState("")



    const setResolutionModal = (e, item) => {
        let resolutionType = e.target.id
        props.setResolutionModal(resolutionType)
        props.setClickedOrderDetailsFunc(item)
    }

    const handlePageChange = (event, value) => {
        props.onPageChange(value)
    }

    const downloadImage = async (imagePath) => {
        // const fileUrl = process.env.REACT_APP_API_URL + "/order/image/" + imagePath;
        // window.open(fileUrl);
        dispatch(downloadFile(imagePath));
    };

    const setExpandPanelFunc = (index) => {
        props.setExpandPanelFunc(index)
    }

    const toggleFunction = (item, value) => {
        setselectOrderId("")
        updatefetchApiForChatMessage(item, value)
    }

    const updatefetchApiForChatMessage = async (item, checktype) => {

        const token = localStorage.getItem('token');

        let userAuth
        if (checktype == "BUYER") {
            if (item.buyerInfo?.locationsId) {
                userAuth = item.buyerInfo.locationsId.toString()
            }
            else {
                userAuth = item.buyerInfo?.locationId
            }
        }

        else if (checktype == "SELLER") {
            if (item.sellerInfo?.locationsId) {
                userAuth = item.sellerInfo.locationsId.toString()
            }
            else {
                userAuth = item.sellerInfo?.locationId
            }
        }
        let data = {
            userAuth: userAuth,
            userType: checktype,
            orderId: item.orderId,
            admin: "demo",
            claimId: item.claimId
        }

        let response = await dispatch(updateReceivedClaimMessageForAdmin(data, token));

        if (response && response.status === 'SUCCESS') {
        } else {
            if (response.statusCode === 401) {
                localStorage.removeItem('token')
                history.push('/sign-in')
                window.location.reload(false);
            }
        }

    }

    return (
        <>
            {claimsDataList && claimsDataList.map((item, index) => {
                return (
                    <>
                        <InnerBoxes>
                            <div className='first-row' style={{ backgroundColor: "" }}>
                                <div style={{ display: 'grid', gridTemplateColumns: "repeat(auto-fit, minmax(238px, 1fr))", alignItems: 'center' }}>
                                    <p>Ticket No : <span>{item.claimId}</span></p>
                                    <p>Order Id : <span>{item.orderId}</span></p>
                                    <button onClick={() => downloadImage(item.fileBOL)}>Download BOL</button>

                                </div>

                                <div style={{ textAlign: 'end', backgroundColor: "" }}>
                                    {props.expandPanel === index ? <h4 onClick={() => setExpandPanelFunc()}>Show Less <i></i></h4> :
                                        <h5 onClick={() => setExpandPanelFunc(index)
                                        }>Show More <i></i></h5>
                                    }

                                </div>
                                <div>
                                </div>
                            </div>

                            {props.expandPanel !== index &&
                                <>
                                    <h3>Claim Details</h3>
                                    <div className='second-row'>
                                        <p>Issue Type : <span>{item.issueType}</span></p>
                                        {item.issueType !== 'BOL' &&
                                            <>
                                                <p >Claim Quantity : <span>{item.totalPalletQuality + item.totalPalletQuantity}</span></p>
                                                <p >Total Price : <span>$ {(item.claimTotalPrice)?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></p>
                                            </>
                                        }
                                        <p>Comments : <span>{item.comments}</span></p>
                                    </div>

                                </>
                            }

                            {props.expandPanel === index &&
                                <>

                                    {/*  recent chat related codes, dont delete it */}

                                    <Container className='chat-section'>
                                        <div style={{ marginRight: "20px", marginTop: "10px" }}>
                                            <ChatBtn
                                                onClick={() => {
                                                    setuserTypeforApi("buyer")
                                                    // setclaimRaisedToggleForBuyer(!claimRaisedToggleForBuyer)
                                                    setselectOrderId(item.orderId)
                                                    setTimeout(
                                                        () => {
                                                            updatefetchApiForChatMessage(item, "BUYER")
                                                        },
                                                        4000
                                                    );
                                                }}


                                            >
                                                <BiChat />

                                                <strong>Chat with Buyer</strong>
                                                {userTypeforApi != "buyer" &&
                                                    <AdminMessageCount item={item} userType="BUYER" />
                                                }

                                            </ChatBtn>
                                        </div>

                                        <div style={{ marginRight: "20px", marginTop: "10px" }}>
                                            <ChatBtn
                                                onClick={() => {
                                                    setuserTypeforApi("seller")
                                                    // setclaimRaisedToggleForSeller(!claimRaisedToggleForSeller)
                                                    setselectOrderId(item.orderId)
                                                    setTimeout(
                                                        () => {
                                                            updatefetchApiForChatMessage(item, "SELLER")
                                                        },
                                                        4000
                                                    );


                                                }}

                                            >
                                                <BiChat />

                                                <strong>Chat with Seller</strong>
                                                {userTypeforApi != "seller" &&
                                                    <AdminMessageCount item={item} userType="SELLER" />
                                                }

                                            </ChatBtn>
                                        </div>
                                        {userTypeforApi == "buyer" && selectOrderId == item.orderId &&
                                            <AdminBuyerChatBox toggleFunction={toggleFunction} item={item} userTypeValue={userTypeforApi} />
                                        }
                                        {userTypeforApi == "seller" && selectOrderId == item.orderId &&
                                            <AdminSellerChatBox toggleFunction={toggleFunction} item={item} userTypeValue={userTypeforApi} />
                                        }
                                        {/* <AdminChatBox toggleFunction={toggleFunction} item={item} userTypeValue={userTypeforApi}/>     */}
                                    </Container>
                                    <div style={{ backgroundColor: "" }}>

                                        <h3>Claim Details:</h3>
                                        <div className='detail-section' >
                                            <div>
                                                <p>Claim Date</p>
                                                <p>{moment(item.created * 1000).format("MM/DD/YYYY")}</p>
                                            </div>
                                            <div>
                                                <p>Claim Type</p>
                                                <p>{item.issueType}</p>
                                            </div>
                                            <div>
                                                <p>Discrepancy Details</p>
                                                <p>{item.comments}</p>
                                            </div>
                                            <div>
                                                <p>Base</p>
                                                <p>$ {item.pricePerPallet?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                            </div>


                                            {item.issueType !== 'BOL' &&
                                                <>
                                                    <div>
                                                        <p>Total Price</p>
                                                        <p>$ {(item.claimTotalPrice)?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                                    </div>
                                                    {(item.issueType === 'BOTH' || item.issueType === 'QUANTITY') &&
                                                        <div>
                                                            <p>Claimed Quantity</p>
                                                            <p>{item.totalPalletQuantity}</p>
                                                        </div>
                                                    }
                                                    {(item.issueType === 'BOTH' || item.issueType === 'QUALITY') &&
                                                        <div>
                                                            <p>Claimed Quality</p>
                                                            <p>{item.totalPalletQuality}</p>
                                                        </div>
                                                    }
                                                </>
                                            }

                                        </div>




                                        <h3>Original Load Details:</h3>
                                        <div className='detail-section'>

                                            <div>
                                                <p>Order Id</p>
                                                <p>{item.orderId}</p>
                                            </div>
                                            <div>
                                                <p>PO Number</p>
                                                <p>{(item.poNumber && item.poNumber?.trim() !== '') ? item.poNumber : 'NA'}</p>
                                            </div>
                                            <div>
                                                <p>Mode</p>
                                                <p>{item.addressType === 'PICKUP' ? 'Pickup' : 'Delivery'}</p>
                                            </div>
                                            <div>
                                                <p>Qty</p>
                                                <p>{item.totalLotQty}</p>
                                            </div>
                                            <div>
                                                <div className='detail-section-mobile-view-one'>
                                                    <div>
                                                        <p>Ship From</p>
                                                        <div className='detail-section-mobile-view-two'>
                                                            <p>{item.shipFrom?.name?.trim()}</p>
                                                            <p>{item.shipFrom?.line1}</p>
                                                            {item.shipFrom?.line2 && <p>{item.shipFrom?.line2?.trim()}</p>}
                                                            <p>{item.shipFrom?.city?.trim()}, {item.shipFrom?.state?.trim()} {item.shipFrom?.zip?.trim()}</p>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <p>Ship To</p>
                                                        <div className='detail-section-mobile-view-two'>
                                                            <p>{item.shipTo?.name?.trim()}</p>
                                                            <p>{item.shipTo?.line1}</p>
                                                            {item.shipTo?.line2 && <p>{item.shipTo?.line2?.trim()}</p>}
                                                            <p>{item.shipTo?.city?.trim()}, {item.shipTo?.state?.trim()} {item.shipTo?.zip?.trim()}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div className='detail-section-mobile-view-one'>
                                                    <div>
                                                        <p>Seller Info</p>
                                                        <div className='detail-section-mobile-view-two'>
                                                            <p>{item.sellerInfo?.companyName?.trim()}</p>
                                                            <p>{item.sellerInfo?.address?.line1}</p>
                                                            {item.sellerInfo?.address?.line2 && <p>{item.sellerInfo?.address?.line2?.trim()}</p>}
                                                            <p>{item.sellerInfo?.address?.city?.trim()}, {item.sellerInfo?.address?.state?.trim()} {item.sellerInfo?.address?.zip?.trim()}</p>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <p>Buyer Info</p>
                                                        <div className='detail-section-mobile-view-two'>
                                                            <p>{item.buyerInfo?.companyName?.trim()}</p>
                                                            <p>{item.buyerInfo?.address?.line1}</p>
                                                            {item.buyerInfo?.address?.line2 && <p>{item.buyerInfo?.address?.line2?.trim()}</p>}
                                                            <p>{item.buyerInfo?.address?.city?.trim()}, {item.buyerInfo?.address?.state?.trim()} {item.buyerInfo?.address?.zip?.trim()}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {tabType === 'resolvedClaims' &&
                                            <>
                                                <h3>Resolution Details:</h3>
                                                <div className='detail-section'>
                                                    <div>
                                                        <p>Resolution Type</p>
                                                        <p>{item.adminResolutionClaimDetails &&
                                                            item.adminResolutionClaimDetails?.action === 'EXCHANGE' ? 'Exchange Damaged or Supply Missing' :
                                                            item.adminResolutionClaimDetails?.action === 'CREDIT' ? 'Issue Credit for Missing or Damaged' :
                                                                item.adminResolutionClaimDetails?.action === 'ASSIGNED_BACK' ? 'Assign Back to Seller' :
                                                                    item.adminResolutionClaimDetails?.action === 'NOACTION' ? 'No Action' :
                                                                        item.adminResolutionClaimDetails?.action === 'PT_DISCOUNT' ? 'PT Override' : ''
                                                        }</p>
                                                    </div>
                                                    <div>
                                                        <p>Comments</p>
                                                        <p>{item.adminResolutionClaimDetails?.discription}</p>
                                                    </div>
                                                    {(item.adminResolutionClaimDetails?.action === 'EXCHANGE' || item.adminResolutionClaimDetails?.action === 'CREDIT' || item.adminResolutionClaimDetails?.action === 'PT_DISCOUNT') &&
                                                        <div>
                                                            <p>Discount Amount</p>
                                                            <p>$ {item.adminResolutionClaimDetails?.discountAmount?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                                        </div>
                                                    }
                                                    <div>
                                                        <p>Resolved Date</p>
                                                        <p>{item.adminResolutionClaimDetails?.created ? moment(item.adminResolutionClaimDetails?.created * 1000).format("MM/DD/YYYY") : ''}</p>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                    {tabType === 'pendingClaims' &&
                                        <div className='third-row'>
                                            <div>
                                                {item.issueType !== 'BOL' && !item.orderId.includes('exchange') && (
                                                    <button id='exchangePopUp' onClick={(e) => setResolutionModal(e, item)}>
                                                        Exchange Damaged or Supply Missing
                                                    </button>
                                                )}
                                                {item.issueType !== 'BOL' && <button id='issueCreditPopUp' onClick={(e) => setResolutionModal(e, item)}>Issue Credit for Missing or Damaged</button>}
                                                <button id='assignBackPopUp' onClick={(e) => setResolutionModal(e, item)}>Assign Back to Seller</button>
                                                <button id='noActionPopUp' onClick={(e) => setResolutionModal(e, item)}>No Action</button>
                                                {item.issueType !== 'BOL' && <button id='ptOverridePopUp' onClick={(e) => setResolutionModal(e, item)}>PT Override</button>}
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                        </InnerBoxes>
                    </>
                )
            })}
            {claimsDataList?.length === 0 && <p style={{ textAlign: 'center' }}>No records found</p>}
            {claimsDataList?.length !== 0 && <Pagination
                count={totalPagesCount}
                page={pageNumber}
                onChange={handlePageChange} />}
        </>
    )
}

export default ClaimDetails